import React, { Component } from 'react';
import Helmet from 'react-helmet';
import styled from 'styled-components';

import LeftMenuButton from './LeftMenuButton';
import RightNextButton from './RightNextButton';
import StepButton from './StepButton';

export default class Navbar extends Component {
  render() {
    return (
      <Container>
        <Helmet
					title="Signup"
					meta={[
						{ charset: 'utf-8' },
						{ name: 'viewport', content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no' },
						{ name: 'description', content: 'Signup' },
					]}
					link={[
						{ href: 'https://fonts.googleapis.com/css?family=Roboto+Slab|Karla', rel: 'stylesheet' },
					]}
				/>
        <div style={{
          // position: 'absolute',
          height: 75,
          width: 965,
          backgroundColor: 'none',
          top: 35,
          justifyContent: 'space-between',
          flexDirection: 'row',
          display: 'flex',
          zIndex: 1,
          margin: 'auto',
          marginTop: 35,
        }}>
          <LeftMenuButton
            currentActive={this.props.currentActive}
            onClick={this.props.onClickLeft}
          />
          {this.props.steps.map((step, index) => (
            <StepButton
              key={index}
              step={step}
              index={index}
              currentActive={this.props.currentActive}
              onClick={this.props.onClickStep(index)}
            />
          ))}
          <RightNextButton
            valid={this.props.valid}
            onClick={this.props.onClickRight}
          />
        </div>
      </Container>
    );
  }
}

const Container = styled.div`
  position: fixed;
  width: 100%;
  background-color: #5d81ec;
  height: 75px;
  display: flex;
  justify-content: flex-start;
  -webkit-filter: drop-shadow(0px 2px 2px #a5a5a5);
  filter: drop-shadow(0px 2px 2px #a5a5a5);
  z-index: 9999;
`;



// WEBPACK FOOTER //
// ./client/redesign/signup/Main/Navbar/index.js